import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import ChatWidget from "../components/site/ChatWidget";
import { CONTACT } from "../lib/api";

export default function About() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-16 max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-[0.22em] text-primary mb-3">About</div>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
          Since {CONTACT.since}, we&apos;ve built our name one careful move at a time.
        </h1>
        <div className="mt-10 grid lg:grid-cols-2 gap-10">
          <div className="aspect-[4/3] rounded-2xl overflow-hidden">
            <img
              src="https://images.pexels.com/photos/4483938/pexels-photo-4483938.jpeg"
              className="w-full h-full object-cover"
              alt="Team packing"
            />
          </div>
          <div className="text-muted-foreground leading-relaxed space-y-5 text-[15px]">
            <p>
              Express Logistics Packers And Movers started in the by-lanes of Bowenpally,
              Hyderabad. Our founder — a former ops manager at a national moving chain —
              was tired of watching families lose sentimental things to careless freelance crews.
            </p>
            <p>
              So we did the opposite. Every crew member is on our payroll, uniformed and trained.
              Every truck is our own, GPS-tracked. Every fragile item gets a real wooden crate,
              not a &ldquo;we&apos;ll be careful&rdquo; promise. And every move gets its own ops manager who
              texts you updates every few hours.
            </p>
            <p>
              Today, we've moved <b className="text-foreground">9,800+ homes</b> across India,
              hold a <b className="text-foreground">4.7★</b> rating from{" "}
              <b className="text-foreground">{CONTACT.reviews}</b> Google reviews, and still answer
              the phone within 3 rings. That last part matters as much as anything else.
            </p>
          </div>
        </div>

        <div className="mt-16 grid sm:grid-cols-3 gap-6">
          {[
            { n: "9,800+", l: "Homes moved" },
            { n: "12", l: "Own trucks" },
            { n: "0 ₹", l: "Hidden charges" },
          ].map((s) => (
            <div key={s.l} className="rounded-2xl border border-border p-8 bg-muted/40">
              <div className="font-display text-4xl">{s.n}</div>
              <div className="mt-2 text-xs uppercase tracking-widest text-muted-foreground">{s.l}</div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
      <ChatWidget />
    </div>
  );
}
